import { Component, AfterViewInit, OnInit } from '@angular/core';

declare const lucide: any;

@Component({
  selector: 'app-gcc-flex',
  templateUrl: './gcc-flex.component.html',
  styleUrls: ['./gcc-flex.component.css']
})
export class GccFlexComponent implements OnInit, AfterViewInit {
  indiaAdvantages = [
    { icon: 'users', title: 'Unmatched Talent Depth', text: 'It offers unmatched talent depth, innovation ecosystems, and cost advantages — across engineering, AI/ML, finance, operations, and customer experience.' },
    { icon: 'award', title: 'Mature Leadership Pool', text: 'With a mature leadership pool and cross-domain expertise' },
    { icon: 'globe', title: 'Strategic Time-Zone Advantage', text: 'With strategic time-zone advantage for seamless global collaboration' },
    { icon: 'lightbulb', title: 'Thriving R&D Ecosystem', text: 'With a thriving R&D and innovation hub ecosystem' },
    { icon: 'shield-check', title: 'Robust IP Protection', text: 'Strong intellectual property laws and enforcement provide security for innovation and proprietary technologies' },
    { icon: 'trending-up', title: 'Scalable Digital Infrastructure', text: 'World-class digital infrastructure, cloud readiness, and connectivity enable seamless operations at scale' }
  ];

  gccFlexDelivers = [
    { icon: 'check-circle', title: 'Entity Setup & Compliance', text: 'Risk-free governance, handled end-to-end' },
    { icon: 'building-2', title: 'Real Estate & Infrastructure', text: 'Branded, secure facilities in top Indian tech hubs' },
    { icon: 'users', title: 'Talent Acquisition & Retention', text: 'AI-led recruitment, HR operations & retention frameworks' },
    { icon: 'wallet', title: 'Finance & Operations', text: 'Transparent payroll, accounting & tax administration' },
    { icon: 'shield-check', title: 'IT & Security', text: 'Enterprise-grade systems, cybersecurity, and monitoring' },
    { icon: 'graduation-cap', title: 'HR & Culture Integration', text: 'Custom induction, expat support, and continuous learning' }
  ];

  journey = [
    { step: '1', title: 'Start Lean', text: 'Begin with a small, branded team — no heavy CapEx or overheads' },
    { step: '2', title: 'Scale Fast', text: 'Expand operations rapidly as business grows' },
    { step: '3', title: 'Transition Smoothly', text: 'Move to a fully owned GCC when ready — without losing IP, talent, or momentum' }
  ];

  gccFlexDifferent = [
    { 
      title: 'Speed-to-Value', 
      description: 'Operational in 90 days or less',
      icon: 'rocket'
    },
    { 
      title: 'Zero CapEx', 
      description: 'Pay-as-you-grow flexibility',
      icon: 'wallet'
    },
    { 
      title: 'No Local Entity Risk', 
      description: 'EPPS manages all compliance & legal frameworks',
      icon: 'shield-check'
    },
    { 
      title: 'Talent Edge', 
      description: "Access India's most skilled, innovation-driven professionals",
      icon: 'users'
    },
    { 
      title: 'Cultural Alignment', 
      description: 'Tailored onboarding aligned with your HQ ethos',
      icon: 'globe'
    },
    { 
      title: 'Scalable Framework', 
      description: 'Seamless transition from managed model to full ownership',
      icon: 'trending-up'
    }
  ];

  // Flowchart definition - now handled by the component itself
  flowchartDefinition = '';
  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }

    // Re-initialize icons after a short delay to ensure DOM is ready
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 100);

    const animatedElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-animate]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target as HTMLElement;
          el.classList.add('in-view');
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });

    animatedElements.forEach(el => observer.observe(el));
  }
}


